"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactIntersection = require("react-intersection");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var IntersectionImage =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(IntersectionImage, _React$PureComponent);

  function IntersectionImage() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      isLoaded: false
    });

    _defineProperty(_assertThisInitialized(_this), "image", void 0);

    _defineProperty(_assertThisInitialized(_this), "imgRef", (0, _react.createRef)());

    _defineProperty(_assertThisInitialized(_this), "checkIsIntersecting", function (_ref) {
      var isIntersecting = _ref.isIntersecting;

      if (isIntersecting) {
        _this.loadImage();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onLoad", function () {
      if (_this.imgRef.current && _this.props.src) {
        _this.imgRef.current.src = _this.props.src;

        if (_this.props.srcset) {
          _this.imgRef.current.srcset = _this.props.srcset;
        }

        _this.setState({
          isLoaded: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onError", function () {
      if (_this.imgRef.current && _this.state.isLoaded) {
        _this.setState({
          isLoaded: false
        });
      } // proceed to load image the old fashion way
      // (most likely Firefox not liking decode)


      _this.onLoad();
    });

    _defineProperty(_assertThisInitialized(_this), "loadImage", function () {
      _this.image = new Image();
      _this.image.src = _this.props.src ? _this.props.src : '';
      _this.image.srcset = _this.props.srcset ? _this.props.srcset : '';

      if (_this.image.decode) {
        _this.image.decode().then(_this.onLoad)["catch"](_this.onError);
      } else {
        _this.image.onload = _this.onLoad;
        _this.image.onerror = _this.onError;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "unloadImage", function () {
      if (_this.image) {
        _this.image.onerror = null;
        _this.image.onload = null;
        _this.image.src = '';
        _this.image.srcset = '';
        delete _this.image;
      }
    });

    return _this;
  }

  var _proto = IntersectionImage.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.src !== this.props.src) {
      this.setState({
        isLoaded: false
      }, this.loadImage);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unloadImage();
  };

  _proto.render = function render() {
    var isLoaded = this.state.isLoaded; // eslint-disable-next-line no-unused-vars

    var _this$props = this.props,
        src = _this$props.src,
        srcset = _this$props.srcset,
        style = _this$props.style,
        props = _objectWithoutPropertiesLoose(_this$props, ["src", "srcset", "style"]);

    var opacity = isLoaded ? 1 : 0;
    return _react["default"].createElement(_reactIntersection.IntersectionElement, {
      onChange: this.checkIsIntersecting,
      once: true
    }, _react["default"].createElement("img", _extends({}, props, {
      ref: this.imgRef,
      src: null,
      style: _objectSpread({}, style, {
        opacity: opacity
      })
    })));
  };

  return IntersectionImage;
}(_react["default"].PureComponent);

exports["default"] = IntersectionImage;

_defineProperty(IntersectionImage, "defaultProps", {
  role: 'presentation',
  alt: ''
});